import { Dispatch } from '@redux/store';
import { createModel } from '@rematch/core';
import { FilterLibraryService } from '@services';
import { FilterLibraryType, PaginationType, ParamData, RootModel } from '@types';
import baseEntity from './base.entity';

interface FilterLibraryStateType {
  ids: { [id: number]: FilterLibraryType };
}

export const filterLibraryEntities = createModel<RootModel>()({
  state: { ids: {} } as FilterLibraryStateType,
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: Dispatch) => ({
    async load(payload): Promise<{ content: FilterLibraryType[] } & PaginationType> {
      const res = await FilterLibraryService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state): Promise<FilterLibraryType> {
      const item = state.filterLibraryEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await FilterLibraryService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await FilterLibraryService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await FilterLibraryService.create(payload));
      } else {
        ({ data: item } = await FilterLibraryService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
    async getParams(): Promise<ParamData[]> {
      const res = await FilterLibraryService.getParams();
      return res.data;
    },
    async publish(payload) {
      const { data } = await FilterLibraryService.publish(payload);
      this.update(data);
      return data;
    },
  }),
});
